<template>
  <a-card title="用户增长明细数据统计">
      <a-button @click="load()">刷新</a-button>
      <div id="echarts-growth" style="width: 100%;height: 600px;"></div>
  </a-card>
</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
// import { SearchOutlined } from '@ant-design/icons-vue';
import axios from 'axios'
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'
import * as echarts from 'echarts';
export default defineComponent({
  components: {
    // UserEditor,
    // SearchOutlined
  },
  data(){
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return {
      today_dt: today.toLocaleDateString(),
      new_user_counts: [],
      loading: false,
       formSearch: {
        user_id: '',
        nickname: '',
        mobile: '',
      },
      xaxis: [],
      series: [],

      uploadLoading: false,
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    renderEcharts(){
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('echarts-growth'));
      // 绘制图表
      let option = {
        title: {
          left: 'center',
          text:  "用户增长数据（5min）"
        },
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 100
          }
        ],
        xAxis: {
          type: 'category',
          data: this.xaxis
        },
        yAxis: {},
        series: [
          {
            type: 'line',
            // smooth: true,
            symbol: 'none',
            areaStyle: {},
            data: this.series
          }
        ]
      };
      myChart.setOption(option);
    },
    async load () {
      this.loading = true
      const rsp = await request.get('/api/stats/new_user/growth', {})
      this.loading = false
      this.new_user_counts = rsp.data.result
      this.xaxis = []
      this.series = []
      for (let o of this.new_user_counts) {
        this.xaxis.push(o.date_time)
        this.series.push(o.user_count)
      }
      this.$nextTick(() => {
        this.renderEcharts()
      })
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.stats-table {
  
}
.stats-table td {
  border: 1px solid #BBB;
  padding: 4px 8px;
}
</style>